export default {
  SET_ITEMS(state, items) {
    state.items = items
  },
  SET_ITEMS_COUNT(state, count) {
    state.itemsCount = count
  },
  SET_QUERY(state, query) {
    state.query = query
  },
  SET_LIMIT(state, limit) {
    state.limit = limit
  },
  SET_SKIP(state, skip) {
    state.skip = skip
  }
}
